import { render, staticRenderFns } from "./ConsumerSettings.vue?vue&type=template&id=33c5c71f"
import script from "./ConsumerSettings.vue?vue&type=script&lang=js"
export * from "./ConsumerSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports